import {
  dateOfBirthUI,
  fullNameUI,
  ssnUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { FULL_SCHEMA } from '../../../utils/imports';

const { veteranFullName, veteranSocialSecurityNumber } = FULL_SCHEMA.properties;
const { date } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    fullName: fullNameUI(),
    dob: dateOfBirthUI(),
    ssn: ssnUI(),
  },
  schema: {
    type: 'object',
    required: ['fullName', 'dob', 'ssn'],
    properties: {
      fullName: veteranFullName,
      dob: date,
      ssn: veteranSocialSecurityNumber,
    },
  },
};
